<template>
  <app-layout title="Manage" :version="version" :bannerSetting="bannerSetting">
    <template #header>
      <div class="flex h-9">
        <h2
          class="flex-1 font-semibold text-xl leading-tight flex items-center"
        >
          {{ project.domain_name }}
        </h2>
      </div>
    </template>

    <div class="mx-auto sm:px-6 lg:px-8">
      <div
        class="
          text-sm
          font-medium
          text-center text-yr-primary-ii-500
          border-b-xx border-gray-200-xx
        "
      >
        <ul class="flex flex-wrap -mb-px">
          <li
            v-for="(tabContent, index) in tabsContent"
            :key="index"
            class="mr-2"
          >
            <Link
              :href="route(`projects.${tabContent.link}.index`, project)"
              class="inline-block p-4 rounded-t-lg border-b-[3px]"
              :class="
                tabContent.link === lastPath
                  ? 'font-bold text-yr-primary-ii-700 border-yr-primary-ii-700'
                  : 'border-transparent hover:border-yr-primary-ii-400'
              "
              >{{ tabContent.title }}</Link
            >
          </li>
        </ul>
      </div>
    </div>

    <div class="pb-12">
      <div class="mx-auto sm:px-6 lg:px-8">
        <div
          class="
            p-6
            sm:px-8
            bg-white
            overflow-hidden
            shadow-xl
            sm:rounded-lg
            grid grid-cols-4
            gap-4
          "
        >
          <div class="col-span-1">
            <jet-button
              v-for="(cookieCategory, index) in cookieCategories"
              :key="index"
              class="
                w-full
                px-4
                py-4
                mb-3
                text-yr-primary-ii-500
                border-yr-primary-ii-300
                hover:bg-yr-primary-500 hover:border-yr-primary-500
                active:bg-yr-primary-600
                focus:outline-none
                focus:border-yr-primary-500
                focus:ring-transparent
                transition
              "
              :class="
                index === 0
                  ? 'bg-yr-primary-500 border-yr-primary-500'
                  : 'bg-transparent'
              "
            >
              {{ cookieCategory.toUpperCase() }}
              <span class="text-gray-400"> {{ "(เร็วๆนี้)" }}</span>
            </jet-button>
            <jet-button
              class="
                hidden
                w-full
                px-4
                py-4
                bg-transparent
                text-yr-primary-ii-500
                border-yr-primary-ii-300 border-dashed
                hover:bg-yr-primary-iii-500
                active:bg-yr-primary-600
                focus:outline-none
                focus:border-yr-primary-500
                focus:ring-transparent
                transition
              "
            >
              <p class="w-full inline-flex justify-center">
                <span class="material-icons mr-2 md-18"> add </span>
                เพิ่มหมวดหมู่ของคุกกี้
              </p>
            </jet-button>
          </div>
          <div class="col-span-3 border-l border-yr-primary-ii-200 pl-4">
            <div class="py-0 hidden">
              <div class="flex justify-between pb-6 border-b">
                <p class="hidden">Language</p>
                <toggle-button
                  class="hidden"
                  toggleTitle="เปิดใช้งาน"
                  toggleCheck
                />
              </div>
              <div class="flex justify-between pt-6 pb-4">
                <p class="font-bold">
                  Necessary
                  <span class="font-normal text-gray-500 text-xs"
                    >(รูปแบบความยินยอม: Notice Only)</span
                  >
                </p>
                <div class="inline-flex text-yr-primary-ii-500 cursor-pointer">
                  <span class="material-icons mr-1 md-18">
                    mode_edit_outline
                  </span>
                  <p class="font-bold underline">แก้ไข</p>
                </div>
              </div>
              <p class="pb-4">
                Necessary cookies are required to help a website usable by
                enabling core functions and access to secure areas of the
                website. The website cannot be function properly without these
                cookies and they are enabled by default and cannot be disabled
                555.
              </p>
            </div>

            <div class="flex justify-between">
              <div
                class="
                  text-sm
                  font-medium
                  text-center text-yr-primary-ii-500
                  border-b-xx border-gray-200-xx
                "
              >
                <ul class="flex flex-wrap -mb-px">
                  <li class="mr-2">
                    <Link
                      href=""
                      class="inline-block p-4 rounded-t-lg border-b-[3px]"
                      :class="'font-bold text-yr-primary-ii-700 border-yr-primary-ii-700'"
                    >
                      คุกกี้
                    </Link>
                  </li>
                  <li class="mr-2">
                    <Link
                      href=""
                      class="inline-block p-4 rounded-t-lg border-b-[3px]"
                      :class="'border-transparent hover:border-yr-primary-ii-400'"
                    >
                      สคริปต์
                    </Link>
                  </li>
                </ul>
              </div>
              <jet-button
                class="
                  cursor-pointer
                  inline-flex
                  items-center
                  pl-2
                  pr-4
                  py-2
                  my-auto
                  bg-yr-primary-ii-500
                  border border-transparent
                  rounded-3xl
                  font-semibold
                  text-xs text-white
                  uppercase
                  tracking-widest
                  hover:bg-yr-primary-ii-600
                  active:bg-yr-primary-ii-700
                  focus:outline-none
                  focus:border-yr-primary-ii-700
                  focus:ring
                  focus:ring-yr-primary-ii-300
                  transition
                "
              >
                <span class="material-icons mr-2 md-18"> add </span>
                เพิ่มคุกกี้
              </jet-button>
            </div>

            <table class="w-full text-sm text-left text-gray-500">
              <thead
                class="
                  text-xs text-yr-primary-ii-500
                  uppercase
                  bg-yr-primary-iii-500
                "
              >
                <tr>
                  <th scope="col" class="px-6 py-3">ชื่อ</th>
                  <th scope="col" class="px-6 py-3">โดเมน / URL</th>
                  <th scope="col" class="px-6 py-3"></th>
                </tr>
              </thead>
              <tbody>
                <tr class="bg-white border-b hover:bg-gray-50">
                  <th
                    scope="row"
                    class="
                      px-6
                      py-4
                      font-medium
                      text-gray-900
                      whitespace-nowrap
                    "
                  >
                    -
                  </th>
                  <td class="px-6 py-4 text-gray-900">
                    <!-- http://localhost:8000/cdn/cookiepop.js -->
                  </td>
                  <td class="px-6 py-4 text-gray-900">-</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import moment from "moment";
import AppLayout from "@/Layouts/AppLayout.vue";
import JetButton from "@/Jetstream/Button.vue";
import JetInput from "@/Jetstream/Input.vue";
import { Link } from "@inertiajs/inertia-vue3";
import ToggleButton from "@/Components/ToggleButton";

export default defineComponent({
  props: ["project", "version", "bannerSetting"],

  components: {
    AppLayout,
    Link,
    JetButton,
    JetInput,
    ToggleButton,
  },

  data() {
    return {
      tabsContent: [
        {
          title: "บันทึกความยินยอม",
          link: "consents",
        },
        {
          title: "สแกนคุกกี้",
          link: "cookies",
        },
        {
          title: "จัดการคุกกี้",
          link: "manage",
        },
        {
          title: "ปรับแต่งแบนเนอร์",
          link: "dialogs",
        },
        // {
        //   title: "ตั้งค่าแบนเนอร์",
        //   link: "banner_setting",
        // },
      ],
      cookieCategories: ["necessary", "analytics", "marketing"],
    };
  },

  computed: {
    lastPath() {
      return window.location.pathname.split("/").pop();
    },
  },

  methods: {
    getHumanDate(date) {
      return moment(date).format("YYYY-MM-DD  h:mm");
    },
  },
});
</script>
